import ShoppingListsSection from './ShoppingListsSection';

export default ShoppingListsSection;
